import { useMemo } from "react";
import { EAffiliateLanguage } from "@devowl-wp/api-real-commerce";
import { __ } from "../utils/i18n.js";
/**
 * Get the allowed languages localized as object.
 */ function useAffiliateLanguage() {
    return useMemo(()=>{
        const result = {};
        Object.keys(EAffiliateLanguage).forEach((key)=>{
            const value = EAffiliateLanguage[key];
            let localized = key;
            switch(value){
                case EAffiliateLanguage.English:
                    localized = __("English");
                    break;
                case EAffiliateLanguage.German:
                    localized = __("German");
                    break;
                default:
                    break;
            }
            result[value] = {
                localized,
                key,
                value
            };
        });
        return result;
    }, []);
}
export { useAffiliateLanguage };
